import { Route } from '@angular/router';
import { CampaignTypeEditComponent } from 'src/app/pages/datasets/campaign-type-edit/campaign-type-edit.component';
import { CampaignTypesComponent } from 'src/app/pages/datasets/campaign-types/campaign-types.component';
import { RoutingID } from '../../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';

export const campaignTypes: Route = {
  path: 'campaign-types',
  title: 'nav.datasets.campaignTypes',
  data: {
    breadcrumb: 'nav.datasets.campaignTypes',
    icon: SbIcons.megaphoneTypes,
    id: RoutingID.campaignTypes,
  },
  children: [
    {
      path: '',
      component: CampaignTypesComponent,
      data: {
        breadcrumb: '',
      },
    },
    {
      path: 'campaign-type-edit/:campaignTypeID',
      title: 'nav.datasets.campaignTypes.edit',
      data: {
        breadcrumb: 'nav.datasets.campaignTypes.edit',
        icon: SbIcons.edit,
        id: RoutingID.campaignTypeEdit,
      },
      children: [
        {
          path: '',
          component: CampaignTypeEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
    {
      path: 'campaign-type-create',
      title: 'nav.datasets.campaignTypes.create',
      data: {
        breadcrumb: 'nav.datasets.campaignTypes.create',
        icon: SbIcons.plus,
        id: RoutingID.campaignTypeCreate,
      },
      children: [
        {
          path: '',
          component: CampaignTypeEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
  ],
};
